import { RemoteObjectStore } from '@softline/core';
import { KundeninfoLeiste } from '../types/kundeninfo-leiste';

export const KundeninfoLeisteStore = RemoteObjectStore.create<KundeninfoLeiste>();
